module.exports = __webpack_public_path__ + "static/img/teens_sexualAbuse.fbfe4caa.png";